import env from 'app/common/services/getEnvironment';

export const WA_DEDICATED_NUMBER_ONBOARDING = 'WA_DEDICATED_NUMBER_ONBOARDING';
export const LOCAL_ROUTING_V2 = 'LOCAL_ROUTING_V2';
export const MESSAGING_PERMISSIONS = 'messaging_permissions';

const PARTOO_PUSH_PREPROD_PROD_ORG_ID = 106844;

export const useFeatureFlagsValues = () => {
    return {
        [WA_DEDICATED_NUMBER_ONBOARDING]: false,
        [LOCAL_ROUTING_V2]: !env.isProd(),
        [MESSAGING_PERMISSIONS]: !env.isProd(),
    };
};

export type FeatureFlags = ReturnType<typeof useFeatureFlagsValues>;
export type FeatureFlag = keyof FeatureFlags;

export const USE_COMPLETION_ENHANCEMENTS: boolean = env.isDev();
export const USE_CUSTOM_ROLES = env.isDev() || env.isStaging();
export const USE_VERIF_FUNNEL = !env.isProd();

export const USE_ORG_MANAGER: boolean = env.isDev() || env.isStaging();
